<template>
  <div>
    <modal
      :show="hasChosenCompany"
      :large="true"
      v-on:close="removeChosenCompany"
      :fire-event="false"
    >
      <h4 slot="title">Confirm Company Details</h4>
      <div>
        <div class="form-group">
          <span class="col-md-3 control-label">Company Name</span>
          <div class="col-md-9">{{ chosenCompany.name }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group">
          <span class="col-md-3 control-label">Company Number</span>
          <div class="col-md-9">{{ chosenCompany.number }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group">
          <span class="col-md-3 control-label">Address Line One</span>
          <div class="col-md-9">{{ chosenCompany.address_line_one }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group">
          <span class="col-md-3 control-label">Address Line Two</span>
          <div class="col-md-9">{{ chosenCompany.address_line_two }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group">
          <span class="col-md-3 control-label">City</span>
          <div class="col-md-9">{{ chosenCompany.city }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group">
          <span class="col-md-3 control-label">Postcode</span>
          <div class="col-md-9">{{ chosenCompany.postcode }}</div>
          <div class="clearfix"></div>
        </div>
        <div class="form-group inline">
          <span class="col-md-3 control-label">Types</span>
          <div class="col-md-9">
            <multiselect
              v-on:input="setType"
              :options="types"
              :multiple="true"
              track-by="id"
              label="label"
              placeholder="Choose..."
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="footer" slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="removeChosenCompany"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="addCompany">
          Save Company
        </button>
      </div>
    </modal>
    <page-header>
      <template #title>
        <h1 class="page-title">Search for a Company</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <inputbox
              name="search"
              placeholder="Company Name or Company Number..."
              v-model="search"
              :stacked="true"
              key="search"
            >
              <div slot="rightBtn">
                <form-button :indicator="indicator" @clicked="findCompany"
                  >Search</form-button
                >
              </div>
            </inputbox>
            <table class="table" v-show="results.length">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Company Number</th>
                  <th>Address Line One</th>
                  <th>Address Line Two</th>
                  <th>City</th>
                  <th>Postcode</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="index" v-for="(result, index) in results">
                  <td v-text="result.name"></td>
                  <td v-text="result.number"></td>
                  <td v-text="result.address_line_one"></td>
                  <td v-text="result.address_line_two"></td>
                  <td v-text="result.city"></td>
                  <td v-text="result.postcode"></td>
                  <td>
                    <button
                      class="btn btn-primary btn-sm"
                      v-on:click.prevent="chooseCompany(result)"
                    >
                      Choose
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      search: null,
      indicator: false,
      results: [],
      chosenCompany: {
        name: null,
        number: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        types: []
      },
      types: []
    };
  },

  computed: {
    hasChosenCompany() {
      return this.chosenCompany.name != null;
    }
  },

  mounted() {
    window.Ajax.get('/company-types')
      .then(response => {
        this.types = response.data;
      })
      .catch(error => {});
  },

  methods: {
    setType(type, id, event) {
      this.chosenCompany.types = type;
    },

    addCompany() {
      window.Ajax.post('/companies', this.chosenCompany)
        .then(response => {
          window.swal(
            'Added',
            'The company was added successfully!',
            'success'
          );
          this.results = [];
          this.search = null;
          this.removeChosenCompany();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "Sorry, we couldn't add the company for you"
          );
        });
    },

    removeChosenCompany() {
      this.chosenCompany.name = null;
      this.chosenCompany.number = null;
      this.chosenCompany.address_line_one = null;
      this.chosenCompany.address_line_two = null;
      this.chosenCompany.city = null;
      this.chosenCompany.postcode = null;
      this.chosenCompany.types = [];
    },

    findCompany() {
      this.indicator = true;

      window.Ajax.get('/companies?q=' + this.search)
        .then(response => {
          this.indicator = false;
          if (Array.isArray(response.data)) {
            this.results = response.data;
          } else {
            this.results = [response.data];
          }
        })
        .catch(error => {
          this.indicator = false;
          window.swal(
            'Oops',
            "Sorry, we couldn't find the company details",
            'error'
          );
        });
    },

    chooseCompany(company) {
      this.chosenCompany.name = company.name;
      this.chosenCompany.number = company.number;
      this.chosenCompany.address_line_one = company.address_line_one;
      this.chosenCompany.address_line_two = company.address_line_two;
      this.chosenCompany.city = company.city;
      this.chosenCompany.postcode = company.postcode;
    }
  }
};
</script>
